<template lang="pug">
  v-layout.wf-justify-content-center(row wrap)
    v-flex(xs12)
      Navbar(:noBackChevron="true")

    template(v-if="showFan")
      v-flex(xs12 mx-auto)
        fan-loader(
          :loading="showFan"
        )
          div(slot="loadingMsg"
            class="full-width text-xs-center headline my-2") Initiating Clearent Integration...
</template>

<script>
import Navbar from 'Components/Navbar.vue'
import FanLoader from 'Components/FanLoader.vue'

export default {
    name: "IntegrationStatus",
    components: {
        FanLoader,
        Navbar,
    },
    data() {
        return {
            showFan: true
        }
    }
}
</script>

<style scoped>

</style>